<ng-container *ngIf="!isDisplayUser$() || questionnaire?.statusToUser != enumReplyStatus.NotStarted">
    <div #trigger (click)="openMenu($event)" class="button" [ngClass]="{'selected':isMenuOpen$()}">
        <img src="/assets/images/grid/menuPoint.svg">
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayOpen]="true" cdkConnectedOverlayBackdropClass="backdrop-selection"
        (backdropClick)="isMenuOpen$.set(false)" [cdkConnectedOverlayOpen]="isMenuOpen$()"
        [cdkConnectedOverlayPositions]="positonArea">
        <div class="overlay-warp auto-height">
            <ng-container *ngIf="!isDisplayUser$() else userMenu">
                <div class="item" (click)="edit()" *ngIf="questionnaire?.status==enumQStatus.Edit && !isDisplayUser$()">
                    <img src="/assets/images/grid/menu/edit.svg">
                    <p translate>grid.menu.edit</p>
                </div>
                <div class="item" *ngIf="questionnaire?.status!= enumQStatus.Edit" (click)="duplicate()">
                    <img src="/assets/images/grid/menu/duplicate.svg">
                    <p translate>grid.menu.duplicate</p>
                </div>
                <div class="item" (click)="view()">
                    <img src="/assets/images/grid/menu/view.svg">
                    <p translate>grid.menu.view</p>
                </div>
                <div class="hr" *ngIf="questionnaire?.status!= enumQStatus.Edit"></div>
                <div class="item" *ngIf="questionnaire?.status!= enumQStatus.Edit" (click)="navToData()">
                    <img src="/assets/images/grid/menu/data.svg">
                    <p translate>grid.menu.data</p>
                </div>
                <!-- <div class="item" *ngIf="!isRoleAdmin$() && questionnaire?.status!= enumQStatus.Edit" (click)="answerIt()">
            <img src="/assets/images/grid/menu/edit.svg">
            <p translate>answer it</p>
        </div> -->
                <div #answerByTrigger>
                    <div class="item"
                        *ngIf="questionnaire?.status!= enumQStatus.Edit && (usersNotAnswered?.length??0)>0"
                        (click)="openAnswerBy()">
                        <img src="/assets/images/grid/menu/responed.svg">
                        <p translate>grid.menu.respondBehalf</p>

                        <img class="arrow scale-img" [ngClass]="{'open-arrow':isAnswerByOpen}"
                            src="/assets/images/types/dropdown-close.svg">
                    </div>
                </div>
                <div class="item" *ngIf="questionnaire?.status != enumQStatus.Edit" (click)="addRecipients()">
                    <img src="/assets/images/popup-recipient/people-icon.svg">
                    <p translate>grid.menu.addRecipients</p>
                </div>
                <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="answerByTrigger"
                    [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayOpen]="true"
                    cdkConnectedOverlayBackdropClass="backdrop-selection" (backdropClick)="isAnswerByOpen=false"
                    [cdkConnectedOverlayOpen]="isAnswerByOpen" [cdkConnectedOverlayPositions]="positonArea2">
                    <div class="overlay-warp answered-by flex-direction-revers-by-dir-he">
                        <ng-container *ngFor="let u of usersNotAnswered">
                            <div (click)="answerItBy(u.guidToUser)" class="flex flex-start-he hover">
                                <div class="user">
                                    <p> {{ u?.user?.firstName ? u?.user?.firstName?.charAt(0)?.toUpperCase() : '' }}</p>
                                    <p>{{ u?.user?.lastName ? u?.user?.lastName?.charAt(0)?.toUpperCase() : '' }}</p>
                                </div>
                                <p class="user-name">{{u.user.firstName}} {{u.user.lastName}}</p>
                            </div>
                        </ng-container>
                    </div>
                </ng-template>
                <div class="hr" *ngIf="questionnaire?.status==enumQStatus.Edit && !isDisplayUser$()"></div>
                <div class="item" *ngIf="questionnaire?.status==enumQStatus.Edit && !isDisplayUser$()"
                    (click)="delete()">
                    <img src="/assets/images/grid/menu/delete-red.svg">
                    <p class="red" translate>grid.menu.delete</p>
                </div>
                <div class="item" *ngIf="isDev && questionnaire?.isUnauthorized && !isDisplayUser$()"
                    (click)="addUnauthorizedUrl()">
                    <img src="/assets/images/grid/menu/link.svg">
                    <p translate>grid.menu.addUnauthorizedUrl</p>
                </div>

            </ng-container>
        </div>
    </ng-template>

</ng-container>

<ng-template #userMenu>
    <div class="item" (click)="viewRequest()">
        <img class="img" src="/assets/images/grid/menu/view.svg">
        <p translate>grid.menu.view</p>
    </div>
    <div class="item" (click)="downloadPdfToUser()">
        <img class="img" src="/assets/images/export/export-report.svg">
        <p translate>grid.menu.downloadPdf</p>
    </div>
    <div class="item" (click)="cancelRequest()" *ngIf="questionnaire?.statusToUser == enumReplyStatus.PendingApproval">
        <img class="img" src="/assets/images/x.svg">
        <p translate>grid.menu.cancelRequest</p>
    </div>
    <div class="img" class="item" (click)="duplicateRequest()" *ngIf="questionnaire?.statusToUser == enumReplyStatus.Rejected">
        <img src="/assets/images/plus.svg">
        <p translate>grid.menu.duplicateRequest</p>
    </div>
    <div class="item" (click)="toggleApprovalFlow()" *ngIf="viewStatusFlow">
        <img class="img" src="/assets/images/history.svg">
        <p translate>grid.menu.activityBoard</p>
    </div>
</ng-template>